import React, { useState, useEffect, useContext } from "react"
import {
    AppBar,
    Button,
    Card,
    CardActionArea,
    CardActions,
    Container,
    Dialog,
    Fab,
    Grid,
    IconButton,
    makeStyles,
    Slide,
    Toolbar,
    Typography,
} from "@material-ui/core"
import { Add, Close } from "@material-ui/icons"

import { Skeleton } from "@material-ui/lab"

import Cabecalho from "../Cabecalho"

import ServicosContext from "../../contexts/servicosContext"
import { valorTotalDaMesa } from "../RegistradorDePedidos/functions"
import { BuscarMesas } from "../../services/integracao"
import { RegistrarLogErro } from "../../services/clientefiel"
import { useHistory } from "react-router-dom"
import ListaPedidosMesa from "./ListaPedidosMesa"
import DetalhesPedido from "./DetalhesPedido"
import { useSnackbar } from "notistack"

const qz = require("qz-tray")

const useStyles = makeStyles(theme => ({
    containerCabecalho: {
        height: "4rem",
        [theme.breakpoints.down("xs")]: {
            height: "3.5rem",
        },
    },
    containerCartoesMesa: {
        padding: "1rem",
        margin: 0,
        width: "100vw",
    },
    cartaoMesa: { height: "9rem", display: "flex", flexDirection: "column" },
    cartaoMesaDados: {
        flex: 5,
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-around",
        alignItems: "center",
    },
    dadosMesa: { display: "flex", flexDirection: "column" },
    statusMesa: {
        padding: "3px",
        textAlign: "center",
    },
    indexPedidoMesa: {
        flex: 1,
        display: "flex",
        alignItems: "center",
    },
    dadosPedidoMesa_container: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-around",
        alignItems: "center",
        flex: 4,
    },
    dadosPedidoMesa: {
        // display: "block",
        // margin: "auto",
    },
    cartaoMesaDesconto: {
        padding: 0,
        flex: 2,
    },
    cartaoMesaDesconto_texto: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "white",
        width: "100%",
        height: "100%",
    },
    valorDesconto: {
        background: "#28a745",
    },
    semDesconto: {
        background: "#6c757d",
    },
    noPadding: { padding: 0 },
    botaoEstaticoAdd: {
        background: "#28a745",
        color: "white",
        position: "fixed",
        bottom: "1.75rem",
        right: "1.75rem",
        "& > span": {
            display: "flex",
            gap: "0.25rem",
        },
        "&:hover": {
            backgroundColor: "#2fc550",
        },
    },
    botaoEstaticoClose: {
        background: "#dc3545",
        color: "white",
        position: "fixed",
        bottom: "5.25rem",
        right: "1.75rem",
        "& > span": {
            display: "flex",
            gap: "0.25rem",
        },
        "&:hover": {
            backgroundColor: "#EB4B5B",
        },
    },
    appBar: {
        "& > div": {
            justifyContent: "space-between",
            margin: "0 3rem",
        },
    },
    opcaoImpressoraLabel: {
        background: "white",
        borderRadius: "10px",
        padding: "2px 10px",
    },
    selecaoImpressora: {
        width: "200px",
        background: "white",
        opacity: 0.85,
    },
    botoesImpressoras: {
        display: "flex",
        gap: "0.75rem",
        "& > button": {
            backgroundColor: "#6c757d",
            color: "white",
        },
    },
    listaPedidosImpressao: {
        maxWidth: "22rem",
        margin: "auto",
        "& > button": { background: "#d8d8d8", margin: "0.25rem 0" },
        "& > button > span": { display: "flex", gap: "0.75rem" },
    },
    botaoImprimir: {
        color: "#28a745",
    },
    botaoFecharMesa: { color: "white", background: "#dc3545" },
}))

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />
})

const GerenciadorMesas = () => {
    const { configuracoes } = useContext(ServicosContext)

    const autorizacao = localStorage.getItem("chaveSistema")

    const [listaMesas, setListaMesas] = useState([])
    const [mesaSelecionada, setMesaSelecionada] = useState()
    const [pedidoSelecionado, setPedidoSelecionado] = useState({})
    const [closeDetalhes, setCloseDetalhes] = useState(false)

    const [impressorasQZ, setImpressorasQZ] = useState([])

    const classes = useStyles()
    const history = useHistory()

    const lista = listaMesas.filter(e => !e.naoTem)

    const { enqueueSnackbar } = useSnackbar()
    const alertStart = (msg, tipo) => {
        enqueueSnackbar(msg, { variant: tipo })
    }

    const handleOpen = async () => {
        try {
            const retorno = await BuscarMesas(autorizacao)
            if (retorno.retornoErro) {
                alertStart(retorno.mensagem, "error")
                return false
            }

            if (retorno.length === 0) {
                setListaMesas([{ naoTem: true }])
            } else {
                setListaMesas(retorno)
            }
        } catch (error) {
            RegistrarLogErro(error, "handleOpenGerenciamentoMesa")
            alertStart("Procure os desenvolvedores! Erro: " + error.message, "error")
        }
    }

    useEffect(() => {
        handleOpen()
    }, [])

    return (
        <div>
            <div className={classes.containerCabecalho}>
                <Cabecalho pagina="Gerenciador de Mesas" gerarQRCode />
            </div>
            <Grid container spacing={4} className={classes.containerCartoesMesa}>
                {!!listaMesas.length &&
                    listaMesas
                        .sort((a, b) => a.numeroMesa - b.numeroMesa)
                        .map((mesa, index) =>
                            mesa?.pedidosMesa?.length ? (
                                <Grid item key={index} xs={4}>
                                    <Card className={classes.cartaoMesa}>
                                        <CardActionArea
                                            onClick={() => setMesaSelecionada(mesa)}
                                            className={classes.cartaoMesaDados}
                                        >
                                            <Typography variant="h2" component="span">
                                                {mesa.numeroMesa}
                                            </Typography>

                                            <span className={classes.dadosMesa}>
                                                <Typography
                                                    variant="body2"
                                                    color="textSecondary"
                                                    component="p"
                                                >
                                                    {mesa.pedidosMesa?.length} pedidos
                                                </Typography>
                                                <Typography variant="body2" component="span">
                                                    {Intl.NumberFormat("pt-BR", {
                                                        style: "currency",
                                                        currency: "BRL",
                                                    }).format(valorTotalDaMesa(mesa.pedidosMesa))}
                                                </Typography>
                                            </span>
                                            <Typography gutterBottom component="h2">
                                                {
                                                    mesa.pedidosMesa[mesa.pedidosMesa?.length - 1]
                                                        .nomePedido /* ?? mesa.pedidosMesa[mesa.pedidosMesa?.length - 1].cliente.nome*/
                                                }
                                            </Typography>
                                        </CardActionArea>
                                        <CardActions className={classes.noPadding}>
                                            <Typography
                                                variant={"button"}
                                                className={[
                                                    classes.statusMesa,
                                                    configuracoes.user.parametros == null
                                                        ? "botaoCinza naoArredondado"
                                                        : configuracoes.user.parametros
                                                              .exibirRegistroPedidos
                                                        ? "botaoVerde naoArredondado"
                                                        : "botaoVermelho naoArredondado",
                                                ].join(" ")}
                                            >
                                                ABERTA
                                            </Typography>
                                        </CardActions>
                                    </Card>
                                </Grid>
                            ) : null
                        )}
            </Grid>
            <Fab
                variant="extended"
                aria-label="add"
                className={classes.botaoEstaticoAdd}
                onClick={() => history.push("/servicos/modulo/registrador-de-pedidos?mesa=0")}
            >
                <Add className={classes.addIcon} />
                Adicionar Pedido
            </Fab>
            <ListaPedidosMesa
                mesa={mesaSelecionada}
                setPedidoSelecionado={setPedidoSelecionado}
                handleClose={() => setMesaSelecionada(undefined)}
                useStyles={useStyles}
                Transition={Transition}
                impressorasQZ={impressorasQZ}
                setImpressorasQZ={setImpressorasQZ}
                alertStart={alertStart}
            />
            <DetalhesPedido
                pedidoSelecionado={pedidoSelecionado}
                handleClose={() => {
                    setCloseDetalhes(true)
                    setTimeout(() => {
                        setPedidoSelecionado({})
                        setCloseDetalhes(false)
                    }, 200)
                }}
                Transition={Transition}
                close={closeDetalhes}
                useStyles={useStyles}
            />
        </div>
    )
}

export default GerenciadorMesas
